import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Spinner } from "shared/atoms/Spinner";

interface Props {
  isError: boolean;
  isLoading: boolean;
}

export const StatusContainer: React.FC<Props> = ({ isError, isLoading }) => {
  const { t } = useTranslation();

  if (!isLoading && !isError) return null;

  return (
    <Container>
      {isLoading && <Spinner dataTestId="spinner" small />}
      {isError && <div>{t("errors.generic")}</div>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  width: 100%;
`;
